import { ApolloLink } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

/* Return all the HTTP error codes extracted from the request error.
 * Codes, plural because each graph resolver maybe have
 * have errored diferrently.
 *
 * {
 *   me {
 *     classes    { ... }
 *     phoneCalls { ... }
 *   }
 * }
 *
 * classes might have 500.
 * phoneCalls might have 401.
 *
 */
// @ts-expect-error ts-migrate(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
function extractStatusCodesFromError(error): Set<string> {
  const codes = new Set();

  if (!Array.isArray(error.graphQLErrors)) {
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Set<unknown>' is not assignable to type 'Set... Remove this comment to see the full error message
    return codes;
  }

  // extract the code for the service metatdata error
  // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'err' implicitly has an 'any' type.
  error.graphQLErrors.forEach((err) => {
    if (err.serviceMetadata?.service_status) {
      codes.add(err.serviceMetadata.service_status.toString());
    }
  });

  // @ts-expect-error ts-migrate(2322) FIXME: Type 'Set<unknown>' is not assignable to type 'Set... Remove this comment to see the full error message
  return codes;
}

type Options = {
  status: {
    [x: string]: Function;
  };
};

/* QueryErrorLink is an apollo link to respond to graphql errors.
 *
 * const queryErrorLink = QueryErrorLink({
 *   status: {
 *     '401': ()      => {},
 *     '403': ()      => {},
 *     '404': ()      => {},
 *     '503': ()      => {},
 *     '*':   (codes) => {},
 *   },
 * });
 *
 * Multiple handlers may be called for the same query, as
 * a single query resolving may error in different ways.
 * A graphql query may return a 403 and a 503 at the same time.
 *
 * options.status is a map of string <=> function because flow
 * doesn not support numbers as object key value yet.
 */
class QueryErrorLink extends ApolloLink {
  constructor(options: Options) {
    super();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'QueryEr... Remove this comment to see the full error message
    this.options = options;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'link' does not exist on type 'QueryError... Remove this comment to see the full error message
    this.link = onError(this.handler);
  }

  handler = (error: any) => {
    const codes = extractStatusCodesFromError(error);

    for (const code of codes) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'QueryEr... Remove this comment to see the full error message
      if (this.options.status[code]) {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'QueryEr... Remove this comment to see the full error message
        this.options.status[code]();
        codes.delete(code);
      }
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'QueryEr... Remove this comment to see the full error message
    if (codes.size > 0 && this.options.status['*']) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'options' does not exist on type 'QueryEr... Remove this comment to see the full error message
      this.options.status['*'](codes);
    }
  };

  request(operation: any, forward: any) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'link' does not exist on type 'QueryError... Remove this comment to see the full error message
    return this.link.request(operation, forward);
  }
}

export { QueryErrorLink };
